import script from "./PlaybackControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlaybackControls.vue?vue&type=script&setup=true&lang=ts"

import "./PlaybackControls.vue?vue&type=style&index=0&id=0ea0f097&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ea0f097"]])

export default __exports__